import React from "react";
import "./CurrentFamilies.css";

//Importing Images
import brightwheelImage from "../assets/brightwheelPhoto2.webp";


const communications = [
    {
        title: "Director Availability",
        text: "The Director maintains an open-door policy and is always available to answer questions, listen to concerns, or provide support. Families are encouraged to reach out anytime to foster open communication.",
        button: "Contact the Director",
        url: "/contact",
        span: "wide",
      },
    {
      title: "Parent Board Meetings",
      text: "Our Parent Board meets regularly to plan events, share updates, and support the school community. Meetings are open to all families, providing an opportunity for parents to have a voice in shaping the preschool experience. For more information on joining the Parent Board, click below!",
      button: "Join the Parent Board",
      url: "/contact",
      span: "wide",
    },
    {
        title: "Brightwheel Parent Portal",
        text: "Brightwheel helps parents stay connected and informed by providing daily activity updates, school event remindres, photos, director notes, classroom newsletters, and even direct messages from teachers. You can also manage check-ins, view billing, and access important school updates all in one convenient place.",
        button: "Access Brightwheel",
        url: "https://schools.mybrightwheel.com/",
        span: "xwide",
        image: brightwheelImage,
    },
  ];
  

function CurrentFamilies() {
  return (

    <div className="families-page">
      {/* --- Hero Section with Argyle Background --- */}
      <section className="families-hero">
        <div className="title-banner">
          <div className="overlay"></div>
          <div className="title-text">
            <h1>Welcome, Current Families!</h1>
            <p>
              Here are some of the communication channels we use to keep you informed, engaged, and connected. 
            </p>
          </div>
        </div>
                {/* <div className="parent-handbook-section communication-card wide">
          <h2>Parent Handbook</h2>
          <p>
            Our Parent Handbook contains important information about our policies, procedures, and guidelines to ensure a safe and nurturing environment for all children. Please take some time to review the handbook to familiarize yourself with our school's practices.
          </p>
          <a
            href="/Users/molly/Desktop/binkley-website-official/binkley-website-official/public/BinkleyPreschoolHandbook.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="card-button"
          >
            View Parent Handbook
          </a>
        </div> */}

        <div className="communications-grid">
          {communications.map((item, index) => (
            <div
              key={index}
              className={`communication-card ${item.span}`}
            >
              
              {item.image && (
                <div className="card-image">
                    <img src={item.image} alt={item.title} />
                </div>
                )}

              <h3>{item.title}</h3>
              <p>{item.text}</p>
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="card-button"
                >
                    {item.button}
                </a>
            </div>
          ))}
        </div>

        </section>
      </div>
  );
}

export default CurrentFamilies;
